<template>
	<div class="home" ref="container">
		<div class="banner_box" v-if="bannerList.length > 0">
			<el-carousel
				height="calc(var(--proportion) * 640px)"
				ref="cardShow"
				arrow="never"
				@change="changeFun"
			>
				<el-carousel-item v-for="(item, index) in bannerList" :key="index">
					<img
						style="width: 100%; height: 100%; object-fit: cover"
						:class="[item.url ? 'cursor_state2;' : 'cursor_state1']"
						:src="item.image"
						@click="goUrl(item.url)"
					/>
				</el-carousel-item>
			</el-carousel>

			<div class="arrow_box" v-if="false">
				<div class="left">
					<img
						class="animate__animated animate__rubberBand"
						@click="arrowClick('left')"
						src="../image/zjt1.png"
						alt=""
					/>
				</div>
				<div class="mid" v-if="bannerList">
					<span style="font-size: 38px; color: #e60000">{{ carouselIndex }}</span
					>/ {{ bannerList.length }}
				</div>
				<div class="right">
					<img @click="arrowClick('right')" src="../image/yjt1.png" alt="" />
				</div>
			</div>
		</div>
		<!-- <div class="nav-box-bj" v-show="lightList.length > 0 && lightList[1]">
      <img src="../image/product/qiu1.png" alt="" />
    </div> -->

		<!-- 导航栏盒子 -->
		<a name="#scrollTop" id="scrollTop"></a>
		<div class="nav-box">
			<div class="nav-box-item">
				<!-- <div class="lable">最新套餐</div>
        <div class="lable">BLT系统</div>
        <div class="lable">KNX系统</div>
        <div class="lable">DMX512</div>
        <div class="lable">开关插座</div>
        <div class="lable">开关</div> -->
				<el-tabs v-model="activeRoomType" @tab-click="handleClickRoomType">
					<el-tab-pane
						:label="item.name"
						:name="index + ''"
						v-for="(item, index) in lightList"
						:key="index"
					></el-tab-pane>
					<!-- <el-tab-pane label="全屋" name="first"></el-tab-pane>
          <el-tab-pane label="客厅" name="second"></el-tab-pane>
          <el-tab-pane label="卧室" name="third"></el-tab-pane>
          <el-tab-pane label="书房" name="fourth"></el-tab-pane> -->
				</el-tabs>
			</div>
		</div>
		<!-- 导航栏盒子 -->

		<!-- 产品盒子 -->
		<div :class="['product-box', '']">
			<div class="big-card" v-if="lightList[activeRoomType]">
				<div
					v-for="item in lightList[activeRoomType].value"
					class="big-card-box wow animate__animated animate__fadeInUp"
					:key="item.id"
					@click="goProductDetail(item.id, item.detail_type, item.detail_url)"
				>
					<div class="lable">
						<div class="title">{{ item.title }}</div>
						<div class="subtitle">{{ item.quantity }}</div>
						<!--  @click="goProductDetail(item.id)" -->
						<div class="button hover-a"> 查看详情<img src="../image/jiantou1.png" alt="" /> </div>
					</div>
					<div class="bj">
						<img :src="item.image_text" alt="" />
					</div>
				</div>
			</div>
			<div class="small-card">
				<div class="top-card" v-if="lightList[activeRoomType]">
					<div
						class="top-card-box wow animate__animated animate__fadeInUp"
						v-for="item in lightList[activeRoomType].content_value"
						:key="item.id"
						@click="goProductDetail(item.id, item.detail_type, item.detail_url)"
					>
						<div class="top-card-img">
							<img :src="item.image_text" alt="" />
						</div>
						<div class="top-card-detail">
							<div class="top-card-title">{{ item.title }}</div>
							<div class="top-card-subtitle">
								{{ item.quantity }}
							</div>

							<!-- @click="goProductDetail(item.id)" -->
							<div class="top-card-button hover-a">
								查看详情<img src="../image/jiantou1.png" alt="" />
							</div>
						</div>
					</div>
				</div>

				<div class="bottom-card" v-if="lightList[activeRoomType]">
					<div class="bottom-card_box0">
						<div
							v-for="item in lightList[activeRoomType].bottom_value"
							:key="item.id"
							class="bottom-card-box wow animate__animated animate__fadeInUp"
							@click="goProductDetail(item.id, item.detail_type, item.detail_url)"
						>
							<div class="bottom-card-img">
								<img :src="item.image_text" alt="" />
							</div>
							<div class="bottom-card-detail">
								<div class="bottom-card-title">{{ item.title }}</div>
								<div class="bottom-card-subtitle">
									{{ item.quantity }}
								</div>

								<!-- @click="goProductDetail(item.id)" -->
								<div class="bottom-card-button hover-a">
									查看详情<img src="../image/jiantou1.png" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 背景线条 -->
			<!-- <img class="left-bj" src="../image/product/qiu2.png" alt="" /> -->
			<!-- <img class="right-bj" src="../image/product/qiu1.png" alt="" /> -->
			<img class="bottom-bj" src="../image/product/qiu3.png" alt="" />
			<!-- 背景线条 -->
		</div>
		<!-- 产品盒子 -->
		<!-- 产品盒子 -->
	</div>
</template>

<script>
	import { $comboList, $getBanner } from '../api/index';

	// @ is an alias to /src
	export default {
		name: 'Home',
		data() {
			return {
				bannerIndex: 0,
				activeRoomType: '0',
				lightList: [],
				bannerList: [],
			};
		},
		// created() {
		//   // let params = this.$route.query.typeActive;
		//   // console.log(params+"=============");
		//   // params ? (this.activeRoomType = params) : "";
		// },
		computed: {
			//计算属性
			carouselIndex() {
				if (this.bannerList.length > 0) {
					return this.bannerIndex + 1 > 10 ? this.bannerIndex + 1 : `0${this.bannerIndex + 1}`;
				} else {
					return 0;
				}
			},
		},
		components: {},
		created() {
			this.comboList();
			this.getBanner();
		},
		mounted() {
			// this.comboList();
			// this.getBanner();
			new this.$wow.WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 0,
				mobile: true,
				live: true,
			}).init();

			let params = this.$route.query.typeActive;
			if (params) {
				this.activeRoomType = params;

				// setTimeout(()=>{ // 根据加载速度 调整时间
				//   window.scrollTo(0, 640);
				//   // this.$nextTick(() => {
				//   //   let doms = document.getElementById("scrollTop");
				//   //   if (!doms) return;
				//   //   doms.scrollIntoView(true);
				//   // });
				// }, 200)
			}
		},
		methods: {
			goUrl(url) {
				if (url) {
					let a = document.createElement('a');
					a.href = url;
					a.target = '_blank';
					a.click();
				}
			},
			//获取轮播图
			getBanner() {
				$getBanner({ page_tyle: 3 }).then((res) => {
					this.bannerList = res.data;
				});
			},
			goProductDetail(id, type, url) {
				if (type == 0) {
					this.$router.push('/product_detail?id=' + id + '&typeActive=' + this.activeRoomType);
				} else {
					window.open(url, '_blank');
				}
			},
			comboList() {
				$comboList({ is_top: 1 }).then((result) => {
					this.lightList = result.data.slice(1);
				});
				// $comboList({ is_top: 0, type: 1 }).then((result) => {
				//   this.lightList = result.data;
				// });
				// $comboList({ is_top: 0, type: 2 })
				//   .then((result) => {
				//     this.lightList = result.data;
				//   })
				//   .catch((err) => {});
			},
			handleClickRoomType(tab, event) {
				// console.log(tab.name, event.clientY, tab);
				let scrollTop = window.scrollY;
				this.$router.push({ query: { typeActive: tab.name } });
				window.scrollTo(0, scrollTop);
			},
			changeFun(e) {
				// console.log(e);
				this.bannerIndex = e;
			},
			arrowClick(val) {
				if (val === 'right') {
					this.$refs.cardShow.next();
				} else {
					this.$refs.cardShow.prev();
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.home {
		position: relative;
	}

	.el-carousel__item img {
		cursor: pointer;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 600px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}
	.banner_box {
		position: relative;
		a {
			display: block;
			height: 100%;
			width: 100%;
		}
		.arrow_box {
			width: calc(var(--proportion) * 270px);
			height: calc(var(--proportion) * 72px);
			background: #100f0f;
			position: absolute;
			bottom: 0;
			right: 0;
			z-index: 999;
			display: flex;
			align-items: center;
			justify-content: space-around;

			display: none;
			.left {
			}
			.mid {
				color: #ffffff;
				line-height: 18px;
				opacity: 0.5;
				font-size: 20px;

				// font-weight: bold;
				display: flex;
			}
			.right {
			}
		}
	}

	.nav-box {
		// background-color: #100f0f;
		// height: calc(var(--proportion) * 168px);
		position: relative;
		.nav-box-item {
			// position: absolute;
			// bottom: 0px;
			// left: 0px;
			// justify-content: center;
			// border: 1px solid #000;
			height: 100%;
			width: 60%;
			margin-left: 20%;
			margin-top: calc(80px - 15px);
			margin-bottom: calc(var(--proportion) * 48px);
			display: flex;
			justify-content: space-around;
			align-items: center;

			::v-deep {
				.el-tabs__nav-wrap {
					overflow: visible;
				}
				.el-tabs__nav-scroll {
					overflow: visible;
				}
			}

			::v-deep .el-tabs__nav-wrap::after {
				background-color: transparent !important;
			}

			::v-deep .el-tabs__item {
				position: relative;
				z-index: 4;
				padding: 0 40px;
				font-size: 24px;
				font-family: Alibaba PuHuiTi 2;
				font-weight: normal;
				color: rgba(255, 255, 255, 0.85) !important;
			}

			::v-deep .el-tabs__active-bar {
				z-index: 1;
				bottom: 2px;
				height: 4px;
				background: #e60000;
			}

			.lable {
				font-size: 20px;

				// font-weight: bold;
				color: #ffffff;
				opacity: 0.85;
			}
		}
		&-bj {
			position: absolute;
			right: 0;
			top: -70px;
		}
	}

	.product-box {
		// background-color: #100f0f;
		position: relative;
		padding-bottom: calc(var(--proportion) * 70px);
		overflow: hidden;
		.big-card-box {
			overflow: hidden;
			cursor: pointer;
		}
		.big-card {
			width: 100%;
			// margin-left: 10%;
			padding: 0 calc(var(--proportion) * 160px);

			display: flex;
			flex-direction: column;
			align-items: center; // 居中

			// margin-bottom: calc(var(--proportion) * 100px);
			.big-card-box {
				position: relative;
				width: calc(var(--proportion) * 1583px);
				height: calc(var(--proportion) * 500px);
				margin-bottom: calc(var(--proportion) * 64px);
				z-index: 10;
				background-color: #252525;

				.lable {
					padding-left: calc(var(--proportion) * 123px);
					padding-top: calc(var(--proportion) * 110px);
					position: absolute;
					.title {
						font-size: calc(var(--proportion) * 40px);

						// font-weight: 600;
						color: #ffffff;
						opacity: 0.85;
						// margin-bottom: calc(var(--proportion) * 40px);
						margin-bottom: calc(var(--proportion) * 25px);
					}
					.subtitle {
						font-size: calc(var(--proportion) * 20px);

						// font-weight: 500;
						color: #ffffff;
						opacity: 0.5;
						margin-bottom: calc(var(--proportion) * 70px);
					}
					.button {
						cursor: pointer;
						width: calc(var(--proportion) * 138px);
						height: calc(var(--proportion) * 48px);
						font-size: calc(var(--proportion) * 14px);

						color: #ffffff;
						font-weight: 400;
						border: 1px solid #ffffff;
						opacity: 0.7;

						text-align: center;
						display: flex;
						align-items: center;
						justify-content: center;
						img {
							width: 12px;
							height: 12px;
							margin-left: 7px;
						}
						&:hover {
							opacity: 1;
							border-color: #e60000;
						}
					}
				}
				.bj {
					height: 100%;
					img {
						width: 100%;
						height: 100%;
					}
				}

				&:last-child {
				}
			}
		}
		.small-card {
			margin-bottom: 50px;
			.top-card {
				width: 100%;
				// margin-left: 10%;
				padding: 0 calc(var(--proportion) * 160px);
				.top-card-box {
					width: calc(var(--proportion) * 1583px);
					margin: 0 auto;
					margin-bottom: calc(var(--proportion) * 40px);
					cursor: pointer;
					display: flex;
					background-color: #252525;
					.top-card-img {
						width: calc(var(--proportion) * 880px);
						height: calc(var(--proportion) * 500px);
						margin-right: calc(var(--proportion) * 82px);
						overflow: hidden;
						display: flex;
						align-items: center;
						img {
							width: 100%;
							height: auto;
						}
					}
					.top-card-detail {
						flex: 1;
						margin-top: calc(var(--proportion) * 87px);
						margin-right: calc(var(--proportion) * 82px);
						width: 378px;
						.top-card-title {
							margin-bottom: calc(var(--proportion) * 37px);
							font-size: calc(var(--proportion) * 40px);

							// font-weight: bold;
							color: #ffffff;
							opacity: 0.85;
						}
						.top-card-subtitle {
							margin-bottom: calc(var(--proportion) * 80px);
							font-size: calc(var(--proportion) * 20px);
							line-height: 32px;

							font-weight: 400;
							color: #ffffff;
							opacity: 0.7;
						}
						.top-card-button {
							font-size: calc(var(--proportion) * 14px);

							font-weight: 400;
							color: #ffffff;
							opacity: 0.85;
							width: calc(var(--proportion) * 124px);
							height: calc(var(--proportion) * 48px);
							border: 1px solid #ffffff;
							opacity: 0.85;
							text-align: center;
							line-height: calc(var(--proportion) * 48px);
							transition: background-color 0.1s linear, color 1s linear;
							-webkit-transition: background-color 1s linear, color 1s linear;
							-moz-transition: background-color 1s linear, color 1s linear;
							-o-transition: background-color 1s linear, color 1s linear;
							img {
								width: 12px;
								height: 12px;
								margin-left: 7px;
							}
							&:hover {
								background: #e60000;
								border: 0px solid #ffffff !important;
							}
						}
					}
				}
			}
			.bottom-card {
				// margin-top: 40px;

				// width: 80%;
				// margin-left: 10%;
				width: 100%;
				padding: 0 calc(var(--proportion) * 160px);
				.bottom-card_box0 {
					display: flex;
					justify-content: space-between;
					align-items: center;
					flex-wrap: wrap;
					width: calc(var(--proportion) * 1583px);

					margin: 0 auto;
					.bottom-card-box {
						cursor: pointer;
						z-index: 999;
						display: flex;
						align-items: center;
						// width: 49%;
						width: calc(50% - (var(--proportion) * 20px));
						height: calc(var(--proportion) * 400px);
						margin-bottom: calc(var(--proportion) * 40px);
						margin-right: calc(var(--proportion) * 40px);
						background-color: #252525;
						&:nth-child(2n) {
							margin-right: 0;
						}
						.bottom-card-img {
							// margin-right: 40px;
							width: calc(var(--proportion) * 400px);
							height: calc(var(--proportion) * 400px);
							overflow: hidden;
							display: flex;
							align-items: center;
							flex-shrink: 0;
							img {
								width: 100%;
								height: 100%;
							}
						}
						.bottom-card-detail {
							// margin-top: 63px;
							// margin: 64px 43px;
							margin: calc(var(--proportion) * 64px) calc(var(--proportion) * 43px);
							width: calc(var(--proportion) * 300px);
							.bottom-card-title {
								font-size: calc(var(--proportion) * 30px);

								// font-weight: bold;
								color: #ffffff;
								opacity: 0.85;
								margin-bottom: calc(var(--proportion) * 31px);
							}
							.bottom-card-subtitle {
								font-size: calc(var(--proportion) * 16px);
								line-height: calc(var(--proportion) * 32px);

								font-weight: 400;
								color: #ffffff;
								opacity: 0.7;
								margin-bottom: calc(var(--proportion) * 80px);
							}
							.bottom-card-button {
								cursor: pointer;
								font-size: calc(var(--proportion) * 14px);

								font-weight: 400;
								color: #ffffff;
								opacity: 0.85;
								width: calc(var(--proportion) * 124px);
								height: calc(var(--proportion) * 48px);
								border: 1px solid #ffffff;
								opacity: 0.85;
								text-align: center;
								line-height: calc(var(--proportion) * 48px);
								transition: background-color 0.1s linear, color 1s linear;
								-webkit-transition: background-color 1s linear, color 1s linear;
								-moz-transition: background-color 1s linear, color 1s linear;
								-o-transition: background-color 1s linear, color 1s linear;
								&:hover {
									background: #e60000;
									border: 0px solid #ffffff !important;
								}
								img {
									width: 12px;
									height: 12px;
									margin-left: 7px;
								}
							}
						}
					}
				}
			}
		}

		.banner-carousel {
			width: 100%;
			height: calc(var(--proportion) * 700px);
		}
		.left-bj {
			position: absolute;
			left: 0;
			top: calc(var(--proportion) * 650px);
		}
		.right-bj {
			position: absolute;
			right: 0;
			top: 0;
			top: calc(var(--proportion) * 1500px);
		}

		.bottom-bj {
			width: 100%;
			position: absolute;
			bottom: 0;
		}
	}
	.nav-box-bj {
		position: absolute;
		top: calc(var(--proportion) * 626px);
		right: 0px;
		width: calc(var(--proportion) * 747px);
		height: calc(var(--proportion) * 863px);
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.at-container {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
	.at-item {
		width: 100%;
		height: 100%;
		animation-name: tilt-in-right-1;
		animation-duration: 1s;
		animation-timing-function: ease;
		animation-delay: 0s;
		animation-iteration-count: 1;
		animation-direction: normal;
		animation-fill-mode: none;
		/* shorthand 
  animation: tilt-in-right-1 1s ease 0s 1 normal none;
  */
	}
	@keyframes tilt-in-right-1 {
		0% {
			transform: rotateX(-30deg) translateX(300px) skewX(30deg);
			opacity: 0;
		}
		100% {
			transform: rotateX(0deg) translateX(0) skewX(0deg);
			opacity: 1;
		}
	}

	// 标题 大小粗细
	.big-card {
		.title {
			font-weight: bold;
			letter-spacing: 2px;
		}
		.subtitle {
			opacity: 0.7 !important;
		}
	}
	.top-card-title {
		// 模块
		font-weight: bold;
		letter-spacing: 2px;
	}
	.bottom-card-title {
		// 模块2
		font-weight: bold;
		letter-spacing: 2px;
	}

	// 轮播图指示器
	::v-deep {
		.el-carousel__button {
			width: calc(var(--proportion) * 40px);
			height: calc(var(--proportion) * 4px);
		}
		.is-active {
			.el-carousel__button {
				background: #e60000 !important;
			}
		}
	}

	.cursor_state1 {
		cursor: initial;
	}
	.cursor_state2 {
		cursor: pointer;
	}
</style>
